import React from 'react'
import { OrgMembersListBaseProps } from './OrgMembersListBase'
import OrgMembersListDesktop from './OrgMembersListDesktop'
import OrgMembersListMobile from './OrgMembersListMobile'

interface OrgMembersListProps extends OrgMembersListBaseProps {
  isMobile: boolean
}

/**
 * Breakpoint switch for the members list. A table and a card stack are genuinely
 * different JSX, so this is a real split rather than a CSS difference.
 */
export const OrgMembersList: React.FC<OrgMembersListProps> = ({ isMobile, ...props }) =>
  isMobile ? <OrgMembersListMobile {...props} /> : <OrgMembersListDesktop {...props} />

export default OrgMembersList
